<template>

    <Toast/>

    <MenuFinancialCompact v-if="userStore.user?.roles?.includes('ROLE_ISORISE')" />
    <MenuHealthCompact v-else />

    <div class="px-6 surface-overlay relative">

        <ul class="list-none py-2 px-0 m-0 flex align-items-center font-medium overflow-x-auto w-full">
            <li class="pr-3"><a class="cursor-pointer">Operational Clarity</a></li>
            <li class="px-2"><i class="pi pi-angle-right text-900"></i></li>
            <li class="px-2"><a class="cursor-pointer text-900 white-space-nowrap">Phone Calls</a></li>
        </ul>

        <div v-show="activeTab === 1" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Manage Phone Calls</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callNewPhoneCall" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>New Phone Call</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callHelp" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-question-circle mr-2"></i>
                                    <span>Help</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callSupport" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-info-circle mr-2"></i>
                                    <span>Contact Support</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <DataTable
                        :value="phoneCalls"
                        :paginator="true"
                        class="p-datatable-gridlines"
                        :rows="100"
                        dataKey="id"
                        :rowsPerPageOptions="[10,20,50,100]"
                        :rowHover="true"
                        :striped-rows="true"
                        :reorderableColumns="true"
                        :sortMode="'multiple'"
                        v-model:filters="filters"
                        filterDisplay="menu"
                        :loading="loading"
                        responsiveLayout="scroll"
                        :globalFilterFields="['firstName', 'lastName', 'email', 'mobile', 'created']">

                        <template #header>
                            <div class="p-grid">
                                <div class="grid">
                                    <div class="col-12 lg:col-6 p-2">
                                        <MultiSelect :modelValue="selectedColumns" :options="columnsFullList"
                                                     optionLabel="header"
                                                     @update:modelValue="onToggleColumns"
                                                     display="chip" placeholder="Select Columns"/>
                                    </div>
                                    <div class="col-12 lg:col-6 p-2">
                                        <MultiSelect :modelValue="selectedStandardFilter" :options="standardFilters"
                                                     optionLabel="header"
                                                     @update:modelValue="onToggleStandardFilters"
                                                     display="chip" placeholder="Select Standard Filter"/>
                                    </div>
                                </div>

                                <div class="grid">
                                    <div class="col-12 lg:col-6 p-2">
                                        <Button type="button" icon="pi pi-filter-slash" label="Clear Search"
                                                class="p-button-outlined p-ml-2" @click="clearFilter()"/>
                                    </div>
                                    <div class="col-12 lg:col-6 p-2">
                                        <Button type="button" icon="pi pi-replay" label="Restore to Original View"
                                                class="p-button-outlined" @click="restoreToOriginal()"/>
                                    </div>
                                </div>

                                <div class="p-col-12 p-md-2">
                                    <span class="p-input-icon-left">
                                        <i class="pi pi-search"/>
                                        <InputText v-model="filters['global'].value"
                                                   placeholder="Keyword Search on First Name, Last Name, Email, Mobile or Created"
                                                   style="width: 100%"/>
                                    </span>
                                </div>
                            </div>

                        </template>

                        <template #empty>
                            No phone calls found.
                        </template>

                        <template #loading>
                            Loading phone calls. Please wait.
                        </template>

                        <Column field="selectAnOption" style="width: 10%">
                            <template #body="{ data }">
                                <SplitButton icon="pi pi-pencil" label="Select" :model="getFilteredItems(data)"
                                             severity="success"
                                             @click="chooseBlankSelection(data)" class="mb-2 mr-2 ml-2 mt-2"/>
                            </template>
                        </Column>

                        <Column field="created" header="Created" :sortable="true"/>

                        <Column field="status" header="Status" :sortable="true">
                            <template #body="{data}">
                                <span class="p-column-title">Status</span>
                                <span v-if="data.status === 'C'"
                                      :class="'status-badge status-' + data.status">Closed</span>
                                <span v-if="data.status === 'I'"
                                      :class="'status-badge status-' + data.status">Initiated</span>
                                <span v-if="data.status === 'R'"
                                      :class="'status-badge status-' + data.status">Responded</span>
                            </template>
                        </Column>

                        <Column v-for="col in selectedColumns"
                                :key="col.field"
                                :field="col.field"
                                :header="col.header"
                                :sortable="col.sortable"/>

                    </DataTable>

                </div>
            </div>
        </div>

        <div v-show="activeTab === 2" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Update Phone Call for {{ this.phoneCall.firstName + ' ' + this.phoneCall.lastName }} on
                        {{ this.phoneCall.created }} </h3>

                    <div class="field">
                        <label for="created">Created Date</label>
                        <Calendar id="created" v-model="parsedCreated" required="true"
                                  :showTime="true"
                                  :showSeconds="false" :showIcon="true" dateFormat="yy-mm-dd"/>

                    </div>

                    <div class="field">
                        <label for="firstName">First Name</label>
                        <InputText id="description" v-model.trim="phoneCall.firstName" required="true"/>
                    </div>

                    <div class="field">
                        <label for="lastName">Last Name</label>
                        <InputText id="description" v-model.trim="phoneCall.lastName" required="true"/>
                    </div>

                    <div class="field">
                        <label for="officeNumber">Office Number</label>
                        <InputText id="description" v-model.trim="phoneCall.officeNumber" required="true"/>
                    </div>

                    <div class="field">
                        <label for="mobile">Mobile</label>
                        <InputText id="description" v-model.trim="phoneCall.mobile" required="true"/>
                    </div>

                    <div class="field">
                        <label for="email">Email</label>
                        <InputText id="description" v-model.trim="phoneCall.email" required="true"/>
                    </div>

                    <div class="field">
                        <label for="message">Message</label>
                        <Textarea v-model.trim="phoneCall.message" :autoResize="true" rows="5" cols="30"/>
                    </div>

                    <div class="field">
                        <label for="status">Status</label>
                        <Dropdown v-model="phoneCall.status" :options="phoneCallTypes" optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select a Status"/>
                    </div>

                    <Button label="Update" class="mr-2 mb-2" @click="updatePhoneCall"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" @click="callReset"></Button>

                </div>
            </div>
        </div>


        <div v-show="activeTab === 3" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Delete Phone Call for {{ this.phoneCall.firstName + ' ' + this.phoneCall.lastName }} on
                        {{ this.phoneCall.created }} </h3>

                    <div class="field">
                        <label for="deleteConfirmationResponse">Do You Wish to Delete this Phone Call?</label>
                        <Dropdown v-model="confirmationResponse" :options="confirmationTypes"
                                  optionLabel="name" optionValue="code"
                                  placeholder="Select a Response"/>
                    </div>

                    <Button label="Delete" class="mr-2 mb-2" @click="deletePhoneCall"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" @click="callReset"></Button>

                </div>
            </div>
        </div>


        <div v-show="activeTab === 4" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Created Phone Call</h3>

                    <div class="field">
                        <label for="created">Created</label>
                        <Calendar id="created" v-model="newPhoneCall.created" required="true" :showTime="true"
                                  :showSeconds="false" :showIcon="true" dateFormat="yy-mm-dd"/>
                    </div>

                    <div class="field">
                        <label for="firstName">First Name</label>
                        <InputText id="description" v-model.trim="newPhoneCall.firstName" required="true"/>
                    </div>

                    <div class="field">
                        <label for="lastName">Last Name</label>
                        <InputText id="description" v-model.trim="newPhoneCall.lastName" required="true"/>
                    </div>

                    <div class="field">
                        <label for="officeNumber">Office Number</label>
                        <InputText id="description" v-model.trim="newPhoneCall.officeNumber" required="true"/>
                    </div>

                    <div class="field">
                        <label for="mobile">Mobile</label>
                        <InputText id="description" v-model.trim="newPhoneCall.mobile" required="true"/>
                    </div>

                    <div class="field">
                        <label for="email">Email</label>
                        <InputText id="description" v-model.trim="newPhoneCall.email" required="true"/>
                    </div>

                    <div class="field">
                        <label for="status">Status</label>
                        <Dropdown v-model="newPhoneCall.status" :options="phoneCallTypes" optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select a Status"/>
                    </div>

                    <div class="field">
                        <label for="message">Message</label>
                        <Textarea v-model.trim="newPhoneCall.message" :autoResize="true" rows="5" cols="30"/>
                    </div>

                    <Button label="Create" class="mr-2 mb-2" @click="createPhoneCall"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" @click="callReset"></Button>

                </div>
            </div>
        </div>

    </div>

    <IsoEvolveFooter/>

</template>

<script>
import IsoEvolveFooter from "@/components/heading/authentication/IsoEvolveFooter.vue";
import MenuHealthCompact from "@/components/menu/health/MenuHealthCompact.vue";
import {useUserStore} from "@/stores/UserStore";
import UserService from "@/service/UserService";
import {FilterMatchMode, FilterOperator} from "primevue/api";
import CompanyService from "@/service/CompanyService";
import PhoneCallService from "@/service/PhoneCallService";
import dayjs from "dayjs";
import MenuFinancialCompact from "@/components/menu/famodule/MenuFinancialCompact.vue";

export default {
    components: {
        MenuFinancialCompact,
        IsoEvolveFooter, MenuHealthCompact
    },
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    created() {
        this.initFilters();

        this.columnsDefault = [
            {field: 'firstName', header: 'First Name', sortable: true},
            {field: 'mobile', header: 'Mobile', sortable: true},
            {field: 'message', header: 'Message', sortable: true}
        ];

        this.columnsFullList = [
            {field: 'firstName', header: 'First Name', sortable: true},
            {field: 'lastName', header: 'Last Name', sortable: true},
            {field: 'email', header: 'Email', sortable: true},
            {field: 'mobile', header: 'Mobile', sortable: true},
            {field: 'officeNumber', header: 'Office Number', sortable: true},
            {field: 'message', header: 'Message', sortable: true}
        ];

        this.selectedColumns = this.columnsDefault;

        this.standardFilters = [
            {field: 'today', header: 'Today'},
            {field: 'thisMonth', header: 'This Month'}
        ];

    },
    async mounted() {

        await this.loadCompanyContext();
    },
    data() {

        return {
            profile: {},
            activeTab: 1,
            companyConfiguration: {},
            userConfiguration: {},
            filters: null,
            loading: true,
            submitted: false,
            filteredItemsCache: new Map(),
            phoneCall: {},
            phoneCalls: null,
            originalPhoneCalls: null,
            newPhoneCall: {},
            confirmationResponse: 'N',
            selectedColumns: null,
            columnsDefault: null,
            columnsFullList: null,
            selectedStandardFilter: null,
            standardFilters: null,
            confirmationTypes: [
                {name: 'Yes', code: 'Y'},
                {name: 'No', code: 'N'}
            ],
            phoneCallTypes: [
                {name: 'Closed', code: 'C'},
                {name: 'Initiated', code: 'I'},
                {name: 'Responded', code: 'R'}
            ]
        }
    },
    computed: {
        parsedCreated: {
            get() {
                return new Date(this.phoneCall.created);
            },
            set(value) {
                this.phoneCall.created = value instanceof Date ? value.toISOString() : '';
            }
        }
    },
    watch: {
        // Clear the cache when appointments data changes
        phoneCalls() {
            this.filteredItemsCache.clear();
        },
        'userStore.activeCompanyId': {
            immediate: false,
            async handler(newCompanyId, oldCompanyId) {
                if (!newCompanyId || newCompanyId === oldCompanyId) {
                    return;
                }

                console.log(
                    '[Appointments][watch] Company changed:',
                    oldCompanyId,
                    '→',
                    newCompanyId
                );

                await this.loadCompanyContext();
            }
        }
    },
    methods: {
        async loadCompanyContext() {
            try {
                // Attempt to get user data
                const userData = await UserService.getUser(this.userStore.user.id);
                this.profile = userData.data;
            } catch (e) {
                console.error("[AppointmentsNew][mounted] Error fetching user data = ", e);
                this.userStore.clearUser();
                this.$router.push('login');
                return;
            }

            this.profile.companyId = this.userStore.activeCompanyId;

            try {
                const [userConfigData] = await Promise.all([
                    UserService.getUserConfig(this.userStore.user.id)
                ]);

                this.userConfiguration = userConfigData.data;
                console.log("[PhoneCalls][mounted] userConfigData.data = ", userConfigData.data);
            } catch (e) {
                console.error("[PhoneCalls][mounted] Could not find user config for user = ", this.userStore.user.id);
            }

            try {
                const [phoneCallData, companyConfigData] = await Promise.all([
                    PhoneCallService.getCompanyPhoneCalls(this.profile.companyId),
                    CompanyService.getCompanyConfiguration(this.profile.companyId)
                ]);

                this.phoneCalls = phoneCallData.data;
                this.originalPhoneCalls = phoneCallData.data;
                console.log("[PhoneCalls][mounted] phoneCallData.data = ", phoneCallData.data);

                this.companyConfiguration = companyConfigData.data;
                console.log("[PhoneCalls][mounted] companyConfigData.data = ", companyConfigData.data);

                this.loading = false;

            } catch (e) {
                console.error("[PhoneCalls][mounted] Error fetching additional data = ", e);
            }

            if (this.$route.query.new === "1") {
                this.callNewPhoneCall();
            }

            console.log("[PhoneCalls][mounted] this.phoneCalls = ", this.phoneCalls);
            console.log("[PhoneCalls][mounted] this.userConfiguration = ", this.userConfiguration);
            console.log("[PhoneCalls][mounted] this.companyConfiguration = ", this.companyConfiguration);

        },
        initFilters() {
            this.filters = {
                'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'firstName': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                },
                'lastName': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                },
                'email': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                },
                'mobile': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                },
                'created': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                }
            }
        },
        clearFilter() {
            this.initFilters();
        },
        restoreToOriginal() {
            window.location.reload();
        },
        callReset() {
            this.activeTab = 1;
        },
        callNewPhoneCall() {
            this.newPhoneCall = {};
            this.activeTab = 4;
        },
        callHelp() {
            console.log('[ConfigurationBilling][callHelp] Start.');
        },
        callSupport() {
            console.log('[ConfigurationBilling][callSupport] Start.');
        },
        callUpdatePhoneCall(data) {
            this.activeTab = 2;
            this.phoneCall = data;
        },
        callDeletePhoneCall(data) {
            this.activeTab = 3;
            this.phoneCall = data;
        },
        onToggleColumns(value) {
            this.selectedColumns = this.columnsFullList.filter(col => value.includes(col));
        },
        onToggleStandardFilters(value) {

            if (value.length > 1) {
                // Keep the last selected option
                this.selectedStandardFilter = [value[value.length - 1]];
            } else {
                this.selectedStandardFilter = value;
            }

            const isTodaySelected = value.some(item => item.field === "today");
            const isThisMonthSelected = value.some(item => item.field === "thisMonth");

            if (this.phoneCalls !== null) {

                if (isTodaySelected) {
                    // The filter "today" is present in selectedStandardFilters
                    console.log("[PhoneCalls] The filter 'today' is selected.");

                    const today = new Date();
                    const year = today.getFullYear();
                    const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-based in JS
                    const day = String(today.getDate()).padStart(2, '0');
                    const todayStr = `${year}-${month}-${day}`;

                    this.phoneCalls = this.originalPhoneCalls.filter(auditTrail => {
                        // Assuming 'created' is in 'YYYY-MM-DD' format
                        return auditTrail.created.startsWith(todayStr);
                    });

                } else if (isThisMonthSelected) {
                    console.log("[PhoneCalls] The filter 'thisMonth' is selected.");

                    const today = new Date();
                    const year = today.getFullYear();
                    const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-based in JS
                    const monthStr = `${year}-${month}`;

                    this.phoneCalls = this.originalPhoneCalls.filter(auditTrail => {
                        // Assuming 'created' is in 'YYYY-MM-DD' format
                        return auditTrail.created.startsWith(monthStr);
                    });

                } else {
                    // The filter "today" is not present in selectedStandardFilters
                    console.log("[PhoneCalls] No filters were selected.");
                    this.phoneCalls = this.originalPhoneCalls;
                }

            } else {
                // Handle the case when auditTrails is null
                this.phoneCalls = null;
            }
        },
        getFilteredItems(data) {
            if (this.filteredItemsCache.has(data.id)) {
                return this.filteredItemsCache.get(data.id);
            }

            const items = [];

            items.push({
                label: 'Update',
                class: 'mb-4 mr-4 ml-4 mt-4',
                command: () => {
                    console.log('Update action');
                    this.callUpdatePhoneCall(data);
                }
            });

            items.push({
                label: 'Delete',
                class: 'mb-4 mr-4 ml-4 mt-4',
                command: () => {
                    console.log('Delete action');
                    this.callDeletePhoneCall(data);
                }
            });

            console.log('[PhoneCalls][getFilteredItems] items = ', items);

            // Store the computed items in the cache
            this.filteredItemsCache.set(data.id, items);

            return items;
        },
        chooseBlankSelection(data) {
            console.log('[PhoneCalls][chooseBlankSelection] data = ', data);
            this.$toast.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Please select a valid option.',
                life: 3000
            });
        },
        async updatePhoneCall() {
            console.log("[PhoneCalls][updatePhoneCall] Start.");

            this.submitted = true;

            if (this.phoneCall.message.trim()) {

                if (this.phoneCall.id) {

                    try {
                        var editPhoneCallDto = {
                            id: this.phoneCall.id,
                            companyId: this.profile.companyId,
                            firstName: this.phoneCall.firstName,
                            lastName: this.phoneCall.lastName,
                            officeNumber: this.phoneCall.officeNumber,
                            mobile: this.phoneCall.mobile,
                            email: this.phoneCall.email,
                            message: this.phoneCall.message,
                            created: dayjs(this.phoneCall.created, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss'),
                            status: this.phoneCall.status,
                        };

                        const response = await PhoneCallService.updatePhoneCall(this.phoneCall.id, editPhoneCallDto);
                        console.log('[PhoneCalls][updatePhoneCall] Response = ', response);

                        const [phoneCallData] = await Promise.all([
                            PhoneCallService.getCompanyPhoneCalls(this.profile.companyId)
                        ]);

                        this.phoneCalls = phoneCallData.data;
                        this.originalPhoneCalls = phoneCallData.data;
                        console.log("[PhoneCalls][updatePhoneCall] phoneCallData.data = ", phoneCallData.data);

                        this.$toast.add({
                            severity: 'success',
                            summary: 'Successful',
                            detail: 'Updated phone call',
                            life: 3000
                        });
                    } catch (error) {
                        console.error('[PhoneCalls][updatePhoneCall] Error:', error);

                        this.$toast.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: 'Failed to update phone call. Please try again.',
                            life: 3000
                        });
                    }
                }
            }

            this.activeTab = 1;
            this.submitted = false;

        },
        async deletePhoneCall() {
            this.submitted = true;

            if (this.confirmationResponse.trim() === "Y") {

                if (this.phoneCall.id) {

                    try {
                        // Delete the appointment
                        const response = await PhoneCallService.deletePhoneCall(this.phoneCall.id);
                        console.log('[PhoneCalls][deletePhoneCall] Response = ', response);

                        const [phoneCallData] = await Promise.all([
                            PhoneCallService.getCompanyPhoneCalls(this.profile.companyId)
                        ]);

                        this.phoneCalls = phoneCallData.data;
                        this.originalPhoneCalls = phoneCallData.data;
                        console.log("[PhoneCalls][deletePhoneCall] phoneCallData.data = ", phoneCallData.data);

                        this.$toast.add({
                            severity: 'success',
                            summary: 'Successful',
                            detail: 'Deleted phone call',
                            life: 3000
                        });
                    } catch (error) {
                        console.error('[PhoneCalls][deletePhoneCall] Error:', error);

                        this.$toast.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: 'Failed to delete phone call. Please try again.',
                            life: 3000
                        });
                    }
                }

            }

            this.activeTab = 1;
            this.submitted = false;
        },
        async createPhoneCall() {
            this.submitted = true;

            if (this.newPhoneCall.firstName) {

                try {
                    var phoneCallDto = {
                        id: this.newPhoneCall.id,
                        companyId: this.profile.companyId,
                        firstName: this.newPhoneCall.firstName,
                        lastName: this.newPhoneCall.lastName,
                        officeNumber: this.newPhoneCall.officeNumber,
                        mobile: this.newPhoneCall.mobile,
                        email: this.newPhoneCall.email,
                        message: this.newPhoneCall.message,
                        created: dayjs(this.newPhoneCall.created, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss'),
                        status: this.newPhoneCall.status,
                    };

                    const response = await PhoneCallService.createPhoneCall(this.profile.companyId, phoneCallDto);
                    console.log('[PhoneCalls][deletePhoneCall] Response = ', response);

                    const [phoneCallData] = await Promise.all([
                        PhoneCallService.getCompanyPhoneCalls(this.profile.companyId)
                    ]);

                    this.phoneCalls = phoneCallData.data;
                    this.originalPhoneCalls = phoneCallData.data;
                    console.log("[PhoneCalls][deletePhoneCall] phoneCallData.data = ", phoneCallData.data);

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Created phone call',
                        life: 3000
                    });
                } catch (error) {
                    console.error('[PhoneCalls][deletePhoneCall] Error:', error);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to create phone call. Please try again.',
                        life: 3000
                    });
                }
            }

            this.activeTab = 1;
            this.submitted = false;
        }
    },
};
</script>

<style scoped lang="scss">
a {
    text-decoration: none;
}

::v-deep(.p-datatable-frozen-tbody) {
    font-weight: bold;
}

::v-deep(.p-datatable-scrollable .p-frozen-column) {
    font-weight: bold;
}

::v-deep(.p-progressbar) {
    height: .5rem;
    background-color: #D8DADC;

    .p-progressbar-value {
        background-color: #607D8B;
    }
}

.status-badge {
    border-radius: var(--border-radius);
    padding: .25em .5rem;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: .3px;
}

.status-badge {
    &.status-C {
        background: #FFCDD2;
        color: #C63737;
    }

    &.status-I {
        background: #B3E5FC;
        color: #23547B;
    }

    &.status-R {
        background: #ECCFFF;
        color: #694382;
    }

}


.tabview-custom {
    i, span {
        vertical-align: middle;
    }

    span {
        margin: 0 .5rem;
    }
}

.p-tabview p {
    line-height: 1.5;
    margin: 0;
}

.accordion-custom {
    i, span {
        vertical-align: middle;
    }

    span {
        margin: 0 .5rem;
    }
}

.p-accordion p {
    line-height: 1.5;
    margin: 0;
}

.mb-2 {
    margin-bottom: 1rem;
}

.mr-2 {
    margin-right: 1rem;
}

</style>
